import { render, staticRenderFns } from "./AccountModalRegisterComfirmCode.vue?vue&type=template&id=0c52cab2&scoped=true&"
import script from "./AccountModalRegisterComfirmCode.vue?vue&type=script&lang=js&"
export * from "./AccountModalRegisterComfirmCode.vue?vue&type=script&lang=js&"
import style0 from "./AccountModalRegisterComfirmCode.vue?vue&type=style&index=0&id=0c52cab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c52cab2",
  null
  
)

export default component.exports